/**
 * Checks if a route parameter matches any of the provided regex patterns
 * @param param - The route parameter to check
 * @param patterns - Array of regex patterns to match against
 * @returns boolean indicating if the parameter matches any pattern
 */
export function matchRouteParam(param: string, patterns: RegExp[]): boolean {
  if (!param || !patterns.length) {
    return false;
  }
  return patterns.some((pattern) => pattern.test(param));
}

/**
 * Cleans a route parameter by removing language prefixes ('en' or 'es') if they exist at the start of the path
 * @param routeParam - The route parameter to clean
 * @returns The cleaned route parameter without language prefix
 * @example
 * cleanRouteParamFromLangPrefix('/es/hello/world') // returns '/hello/world'
 * cleanRouteParamFromLangPrefix('/eslow') // returns '/eslow'
 * cleanRouteParamFromLangPrefix('/en/en/hello') // returns '/en/hello'
 * cleanRouteParamFromLangPrefix('/england') // returns '/england'
 */
export function cleanRouteParamFromLangPrefix(
  routeParam: string,
  _validLanguages: string[]
): string {
  return stripLanguagePrefix(routeParam);
}
import { stripLanguagePrefix } from "@/utils/language";
